module.exports = __webpack_public_path__ + "img/ai_analysis.78e20699.png";